<h2 id="page-title">Beneficiary List</h2>
<div class="p-input-icon-right date-filter">
  <ng-template #searchIcon>
    <i class="pi pi-search"></i>
  </ng-template>
  <ng-template #clearBeneficiaryNameIcon>
    <i (click)="clearField('beneficiaryAccountName')" class="pi pi-times"></i>
  </ng-template>
  <lib-input
    [iconLeft]="filter.beneficiaryAccountName ? searchIcon : undefined"
    [iconRight]="filter.beneficiaryAccountName ? clearBeneficiaryNameIcon : searchIcon"
    type="text"
    [(ngModel)]="filter.beneficiaryAccountName"
    (ngModelChange)="onSearchInputChange()"
    placeholder="Beneficiary Name"
  >
  </lib-input>

  <ng-template #clearBeneficiaryAccountNoIcon>
    <i (click)="clearField('beneficiaryAccountNo')" class="pi pi-times"></i>
  </ng-template>

  <lib-input
    placeholder="Account No"
    [(ngModel)]="filter.beneficiaryAccountNo"
    (ngModelChange)="onSearchInputChange()"
    type="text"
    [iconLeft]="filter.beneficiaryAccountNo ? searchIcon : undefined"
    [iconRight]="filter.beneficiaryAccountNo ? clearBeneficiaryAccountNoIcon : searchIcon"
  >
  </lib-input>
  <p-datepicker
    [iconDisplay]="'input'"
    inputId="icondisplay"
    [(ngModel)]="dateFilter"
    [showIcon]="true"
    selectionMode="range"
    #datepicker
    (ngModelChange)="onFilterDateChange($event)"
    placeholder="Modified Date"
    styleClass="p-datepicker-w-btn"
    [showButtonBar]="true"
    (onClearClick)="clearField('startCreatedAt')"
  >
  </p-datepicker>
  <lib-button (onClick)="onFilterChange()" [label]="'Search'"></lib-button>
</div>
<table aria-describedby="page-title">
  <thead>
    <tr>
      <th>Beneficiary Name</th>
      <th>Bank</th>
      <th>Account No.</th>
      <th>Created Date</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of datas | async">
      <td>{{ data.beneficiaryAccountName }}</td>
      <td>{{ data.beneficiaryBankName }}</td>
      <td>{{ data.beneficiaryAccountNo }}</td>
      <td>{{ data.createdAt | date: 'dd MMM yyyy HH:mm:ss' }}</td>
      <td></td>
    </tr>
  </tbody>
</table>
<app-pagination
  *ngIf="totalRecord | async as pagination"
  [page]="pagination.page - 1"
  [totalRecords]="pagination.totalItems"
  [rows]="pagination.perPage"
  (pageChange)="onPageChange($event)"
>
</app-pagination>
